// extracted by mini-css-extract-plugin
module.exports = {"recommended-challenge-tooltip":"_1YGQWx","tctooltiptext":"_2hWW85","verified-tag":"_1yg_Dq","verified-tag-text":"_3KTpUc"};